import { Form, Input, Button, Alert } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { MailOutlined, LockOutlined, CheckOutlined } from '@ant-design/icons';
import logo from '../../images/Group.svg';
import logoWhite from '../../images/pl-logo-white.svg';
import APICONST from '../../constants';
import './styles.scss';

const FEATURES = [
  'RFIs, submittals and punch lists in one place',
  'Daily logs and drawings straight from the field',
  'Office and jobsite working from the same plan'
];

const Login = () => {
  const navigate = useNavigate();
  const [errorMessage, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!'
    }
  };

  const onFinish = async (values) => {
    setError(null);
    setLoading(true);
    const url = `${APICONST.LOGIN}`;

    const params = {
      user: {
        email: values.email,
        password: values.password,
        push_token: '',
        platform_name: 'web'
      }
    };

    await axios
      .post(url, params)
      .then((r) => {
        if (r.status === 200) {
          Cookies.set('auth-token', r.data.auth_token, { expires: 1 });
          Cookies.set('company_id', r.data.user.company.unique_reference_id, { expires: 1 });
          Cookies.set('company_name', r.data.user.company.name, { expires: 1 });
          Cookies.set('user', r.data.user.full_name, { expires: 1 });
          Cookies.set('userInfo', JSON.stringify(r.data.user, { expires: 1 }));
          Cookies.set('user_id', r.data.user.unique_reference_id, { expires: 1 });
          const redirectPath = localStorage.getItem('redirectPath') || '/dashboard';
          localStorage.removeItem('redirectPath'); // Clean up after redirect
          navigate(redirectPath);
        }
      })
      .catch((err) =>
        setError(
          err.response?.data?.error ||
            'Unable to reach the server. Please check your connection and try again.'
        )
      )
      .finally(() => setLoading(false));
  };

  const authError = !!errorMessage?.user_authentication;
  const errorText =
    errorMessage?.user_authentication ||
    (typeof errorMessage === 'string'
      ? errorMessage
      : 'Unable to sign in. Please try again or contact support.');

  return (
    <div className="pl-auth">
      <aside className="pl-auth__brand">
        <img className="pl-auth__brand-logo" src={logoWhite} alt="ProjectLoop" />
        <div className="pl-auth__brand-body">
          <h2>
            Keep every project <span>in the loop.</span>
          </h2>
          <p>Construction project management that connects your office, field and partners.</p>
          <ul className="pl-auth__features">
            {FEATURES.map((feature) => (
              <li key={feature}>
                <CheckOutlined />
                {feature}
              </li>
            ))}
          </ul>
        </div>
        <div className="pl-auth__brand-footer">
          © {new Date().getFullYear()} ProjectLoop. All rights reserved.
        </div>
      </aside>

      <main className="pl-auth__main">
        <div className="pl-auth__card">
          <img className="pl-auth__mobile-logo" src={logo} alt="ProjectLoop" />
          <h1 className="pl-auth__title">Welcome back</h1>
          <p className="pl-auth__subtitle">Sign in to your ProjectLoop account</p>

          {errorMessage && (
            <Alert className="pl-auth__alert" type="error" showIcon message={errorText} />
          )}

          <Form
            layout="vertical"
            requiredMark={false}
            onFinish={onFinish}
            validateMessages={validateMessages}>
            <Form.Item
              name="email"
              label="Email or username"
              validateStatus={authError ? 'error' : undefined}
              rules={[{ required: true, message: 'User name/email is required' }]}>
              <Input
                size="large"
                prefix={<MailOutlined />}
                placeholder="you@company.com"
                autoComplete="username"
                autoFocus
              />
            </Form.Item>
            <Form.Item
              name="password"
              label={
                <span className="pl-auth__label-row">
                  Password
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/forgot_password');
                    }}>
                    Forgot password?
                  </a>
                </span>
              }
              validateStatus={authError ? 'error' : undefined}
              rules={[{ required: true, message: 'Password is required' }]}>
              <Input.Password
                size="large"
                prefix={<LockOutlined />}
                placeholder="Enter your password"
                autoComplete="current-password"
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" className="pl-auth__submit" loading={loading}>
              Sign in
            </Button>
          </Form>

          <p className="pl-auth__signup">
            Don&apos;t have an account?
            <a onClick={() => navigate('/signup')}>Create one</a>
          </p>
        </div>
      </main>
    </div>
  );
};
export default Login;
